export const BLACKLISTED_ARTISTS = [
  'dog music',
  'muse',
  'america',
  'free',
  '70s soul jam',
  'ac/dc jam',
  'buffalo traffic jam',
  'cathead jam',
  'club 90s',
];

const normalize = (name?: string | null) =>
  (name || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s]/g, '')
    .trim();

export function isBlacklistedArtistName(name?: string | null): boolean {
  if (!name) return false;
  const n = normalize(name);
  return BLACKLISTED_ARTISTS.some(b => normalize(b) === n);
}

/** Pattern-based filter for tribute bands, compilations, etc. */
const LOW_QUALITY_PATTERNS = [
  /\btribute\b/i,
  /\bcover\s*band\b/i,
  /^\d{2}s\s.+\bjam\b$/i,       // "70s Funk Jam", "80s Rock Jam"
  /\blive\s*band\s*tribute\b/i,
  /\bcelebration\s*of\b/i,
  /\bsalute\s*to\b/i,
  /\bremembering\b/i,
];

export function isLowQualityArtist(name?: string | null): boolean {
  if (!name) return false;
  return LOW_QUALITY_PATTERNS.some(p => p.test(name));
}

/** Combined check: blacklisted OR low-quality pattern */
export function shouldExcludeArtist(name?: string | null): boolean {
  return isBlacklistedArtistName(name) || isLowQualityArtist(name);
}
